import { SimpleForm, TextInput, required, Edit, Toolbar, SaveButton, TopToolbar } from 'react-admin';
import BackButton from '../../Components/BackButton';


const PostEditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);


export const upgradeSystemEdit = () => {
    return (
        <Edit actions={<ActionsToolbar />} mutationMode="optimistic">
            <SimpleForm sx={{ width: { lg: '40%', xs: '100%' } }} toolbar={<PostEditToolbar />}>
                <TextInput label="OTA描述" source="description" validate={[required()]} />
            </SimpleForm>
        </Edit>
    )
};